import { sortData } from './util'

export const priceMap = {
  'vcf': {
    price: 59
  },
  'fastq': {
    price: 99
  }
}

export const impactMap = {
  'HIGH': {
    color: '#FA3D3D',
    font: 'white'
  },
  'MODERATE': {
    color: '#F8C600',
    font: '#333333'
  },
  'LOW': {
    color: '#83C91E',
    font: '#333333'
  },
  'MODIFIER': {
    color: '#006ED6',
    font: 'white'
  },
  'N/A': {
    color: '#AAAAAA',
    font: 'white'
  }
}

export const chromMap = {
  'chr1': {
    title: '1'
  },
  'chr2': {
    title: '2'
  },
  'chr3': {
    title: '3'
  },
  'chr4': {
    title: '4'
  },
  'chr5': {
    title: '5'
  },
  'chr6': {
    title: '6'
  },
  'chr7': {
    title: '7'
  },
  'chr8': {
    title: '8'
  },
  'chr9': {
    title: '9'
  },
  'chr10': {
    title: '10'
  },
  'chr11': {
    title: '11'
  },
  'chr12': {
    title: '12'
  },
  'chr13': {
    title: '13'
  },
  'chr14': {
    title: '14'
  },
  'chr15': {
    title: '15'
  },
  'chr16': {
    title: '16'
  },
  'chr17': {
    title: '17'
  },
  'chr18': {
    title: '18'
  },
  'chr19': {
    title: '19'
  },
  'chr20': {
    title: '20'
  },
  'chr21': {
    title: '21'
  },
  'chr22': {
    title: '22'
  },
  'chrX': {
    title: 'X'
  },
  'chrY': {
    title: 'Y'
  },
  'chrM': {
    title: 'M'
  }
}

export const geneTypeMetadatas = {
  'pgp': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'pgp',
        'gene_filter'
      ],
      title: 'Phenotype'/* ___ */
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'gene_filter': {
    sortOption: {
      key: 'Gene_Variant_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'pgp',
        'gene_filter'
      ],
      title: 'Gene Panel'/* ___ */
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.entries(gene.variants || {}).filter(([_, variant]) => {
      return variant.Mendelian === undefined || variant.Mendelian === mode['mendelian']
    }).map(([vkey]) => vkey)
  },
  'nbs_pathovar': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'nbs_pathovar',
        'nbs_nullvar',
        'nbs_carrier',
        'incidental'
      ],
      title: 'Pathogenic Variants'/* ___ */
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => {
      let phenotyps = (!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}
      return Object.entries(phenotyps).some(([_, phenotype]) => {
        return phenotype.disease_score !== -1
      }) ? Object.keys(phenotyps) : null
    },
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'nbs_nullvar': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'nbs_pathovar',
        'nbs_nullvar',
        'nbs_carrier',
        'incidental'
      ],
      title: 'Null Variants'/* ___ */
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => {
      let phenotyps = (!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}
      return Object.entries(phenotyps).some(([_, phenotype]) => {
        return phenotype.disease_score !== -1
      }) ? Object.keys(phenotyps) : null
    },
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'nbs_carrier': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'nbs_pathovar',
        'nbs_nullvar',
        'nbs_carrier',
        'incidental'
      ],
      title: 'Carrier'/* ___ */
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'incidental': {
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      groups: [
        'nbs_pathovar',
        'nbs_nullvar',
        'nbs_carrier',
        'incidental'
      ],
      title: 'Incidental findings'/* ___ */
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'monitor': {
    special: true,
    sortOption: {
      key: 'inherinext_score',
      order: 'desc'
    },
    tagOption: {
      title: 'Monitor'/* ___ */
    },
    phenotypeFilter: (symbol, gene, caseData, project, mode) => Object.keys((!symbol.startsWith('MT-') ? gene.phenotypes : gene.orphanet_phenotypes) || {}),
    variantFilter: (symbol, gene, caseData, project, mode) => Object.keys(gene.variants || {})
  },
  'filter': {
    display: false,
    tagOption: {
      title: 'Filter'/* ___ */
    }
  },
  // old
  'clinvar': {
    old: true,
    tagOption: {
      title: 'Clinvar'
    }
  },
  'nbs': {
    old: true,
    tagOption: {
      title: 'nbs'/* ___ */
    }
  },
  'nbs_nonmendelian': {
    old: true,
    tagOption: {
      title: 'Nonmendelian'/* ___ */
    }
  }
}

export const predictionMetaDatas = {
  'SIFT4G': {
    key: {
      score: 'SIFT4G_score',
      pred: 'SIFT4G_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'T': true
    }[pred])
  },
  'Polyphen': {
    key: {
      score: 'Polyphen',
      pred: 'Polyphen_pred'
    },
    displayMap: {
      'D': 'Probably Damaging',
      'P': 'Possibly Damaging',
      'B': 'Benign'
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'P': false,
      'B': true
    }[pred])
  },
  'FATHMM': {
    key: {
      score: 'FATHMM_score',
      pred: 'FATHMM_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'T': true
    }[pred])
  },
  'MutationAssessor': {
    key: {
      score: 'MutationAssessor_score',
      pred: 'MutationAssessor_pred'
    },
    displayMap: {
      'H': 'High',
      'M': 'Medium',
      'L': 'Low',
      'N': 'Neutral'
    },
    checkPassed: (score, pred) => ({
      'H': false,
      'M': false,
      'L': true,
      'N': true
    }[pred])
  },
  'PROVEAN': {
    key: {
      score: 'PROVEAN_score',
      pred: 'PROVEAN_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'N': 'Neutral'
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.7) : undefined
  },
  'CADD_phred': {
    key: {
      score: 'CADD_phred',
      pred: 'CADD_phred_pred'
    },
    displayMap: {
      'red': 'Damaging',
      'black': 'Neutral'
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 30) : undefined
  },
  'M_CAP': {
    key: {
      score: 'M_CAP_score',
      pred: 'M_CAP_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.025) : undefined
  },
  'MetaLR': {
    key: {
      score: 'MetaLR_score',
      pred: 'MetaLR_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'T': true
    }[pred])
  },
  'MetaSVM': {
    key: {
      score: 'MetaSVM_score',
      pred: 'MetaSVM_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'T': true
    }[pred])
  },
  'REVEL': {
    key: {
      score: 'REVEL_score',
      pred: 'REVEL_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.7) : undefined
  },
  'BayesDel_addAF': {
    key: {
      score: 'BayesDel_addAF_score',
      pred: 'BayesDel_addAF_pred'
    },
    displayMap: {
      'D': 'Damaging',
      'T': 'Tolerated'
    },
    checkPassed: (score, pred) => ({
      'D': false,
      'T': true
    }[pred])
  },
  'ada': {
    key: {
      score: 'ada_score',
      pred: 'ada_pred'
    },
    displayMap: {
      'red': 'Splice-altering',
      'black': 'Neutral'
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.6) : undefined
  },
  'rf': {
    key: {
      score: 'rf_score',
      pred: 'rf_pred'
    },
    displayMap: {
      'red': 'Splice-altering',
      'black': 'Neutral'
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.6) : undefined
  },
  'GERPpp_NR': {
    key: {
      score: 'GERPpp_NR',
      pred: 'GERPpp_NR_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'GERPpp_RS': {
    key: {
      score: 'GERPpp_RS',
      pred: 'GERPpp_RS_pred'
    },
    displayMap: {
      'red': 'Conserved',
      'black': 'Non-conserved'
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 2) : undefined
  },
  'SiPhy_29way_logOdds': {
    key: {
      score: 'SiPhy_29way_logOdds',
      pred: 'SiPhy_29way_logOdds_pred'
    },
    displayMap: {
      'red': 'Conserved',
      'black': 'Non-conserved'
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 12.17) : undefined
  },
  'SiPhy_29way_pi': {
    key: {
      score: 'SiPhy_29way_pi',
      pred: 'SiPhy_29way_pi_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'gnomAD_g_mt_mitotip': {
    key: {
      score: 'gnomAD_g_mt_mitotip_score',
      pred: 'gnomAD_g_mt_mitotip_score_pred'
    },
    displayMap: {
      'red': 'Likely or possibly pathogenic',
      'black': 'Likely or possibly benign'
    },
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 12.66) : undefined
  },
  'SpliceAI_DS_AG': {
    key: {
      score: 'SpliceAI_DS_AG',
      pred: 'SpliceAI_DS_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'SpliceAI_DS_AL': {
    key: {
      score: 'SpliceAI_DS_AL',
      pred: 'SpliceAI_DS_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'SpliceAI_DS_DG': {
    key: {
      score: 'SpliceAI_DS_DG',
      pred: 'SpliceAI_DS_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'SpliceAI_DS_DL': {
    key: {
      score: 'SpliceAI_DS_DL',
      pred: 'SpliceAI_DS_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? (score < 0.5) : undefined
  },
  'SpliceAI_DP_AG': {
    key: {
      score: 'SpliceAI_DP_AG',
      pred: 'SpliceAI_DP_AG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'SpliceAI_DP_AL': {
    key: {
      score: 'SpliceAI_DP_AL',
      pred: 'SpliceAI_DP_AL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'SpliceAI_DP_DG': {
    key: {
      score: 'SpliceAI_DP_DG',
      pred: 'SpliceAI_DP_DG_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'SpliceAI_DP_DL': {
    key: {
      score: 'SpliceAI_DP_DL',
      pred: 'SpliceAI_DP_DL_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'oe_syn': {
    key: {
      score: 'oe_syn',
      pred: 'oe_syn_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'oe_mis': {
    key: {
      score: 'oe_mis',
      pred: 'oe_mis_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'oe_lof': {
    key: {
      score: 'oe_lof',
      pred: 'oe_lof_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'syn_z': {
    key: {
      score: 'syn_z',
      pred: 'syn_z_pred'
    },
    displayMap: {},
    numberCount: false,
    checkPassed: (score, pred) => (score || (score === 0)) ? true : undefined
  },
  'mis_z': {
    key: {
      score: 'mis_z',
      pred: 'mis_z_pred'
    },
    displayMap: {},
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 3.09) : undefined
  },
  'pLI': {
    key: {
      score: 'pLI',
      pred: 'pLI_pred'
    },
    displayMap: {},
    checkPassed: (score, pred) => (score || (score === 0)) ? (score <= 0.9) : undefined
  }
}

export const omimPhenotypeIDList = [
  '175100',
  '132900',
  '611788',
  '604400',
  '607450',
  '609040',
  '610193',
  '610476',
  '604370',
  '612555',
  '601144',
  '604772',
  '115200',
  '615396',
  '130050',
  '301500',
  '144010',
  '143890',
  '192600',
  '115196',
  '115197',
  '600858',
  '613690',
  '608751',
  '608758',
  '612098',
  '155240',
  '603776',
  '174900',
  '174900',
  '601494',
  '151623',
  '609192',
  '610168',
  '609192',
  '610168',
  '613795',
  '192500',
  '613688',
  '603830',
  '120435',
  '120435',
  '120435',
  '120435',
  '145600',
  '601887',
  '154700',
  '154700',
  '131100',
  '171400',
  '162300',
  '608456',
  '101000',
  '311250',
  '168000',
  '601650',
  '605373',
  '115310',
  '175200',
  '132600',
  '158350',
  '180200',
  '191100',
  '613254',
  '193300',
  '194070',
  '277900'
]

export const getPhenotypeList = values => {
  let phenotypes = values ? sortData(Array.prototype.concat.apply([], Object.entries(values).map(([id, phenotype]) => {
    let length = !phenotype.Phenotype ? 0 : phenotype.Phenotype instanceof Array ? phenotype.Phenotype.length : 1
    let isArray = phenotype.Phenotype instanceof Array
    return (new Array(length)).fill('').map((_, i) => ({
      ...phenotype,
      id: id,
      index: i,
      Inheritance: isArray ? (phenotype.Inheritance[i] || '').split(',') : phenotype.Inheritance instanceof Array ? phenotype.Inheritance : [phenotype.Inheritance],
      Phenotype: isArray ? phenotype.Phenotype[i] : phenotype.Phenotype
    }))
  })), 'disease_score', 'desc') : []
  return phenotypes
}

export const getOrphaPhenotypeList = values => {
  let phenotypes = values ? sortData(Array.prototype.concat.apply([], Object.entries(values).map(([id, phenotype]) => {
    let length = !phenotype.disease ? 0 : phenotype.disease instanceof Array ? phenotype.disease.length : 1
    let isArray = phenotype.disease instanceof Array
    return (new Array(length)).fill('').map((_, i) => ({
      ...phenotype,
      id: id,
      index: i,
      inheritance: isArray ? (phenotype.inheritance[i] || '').split(',') : phenotype.inheritance instanceof Array ? phenotype.inheritance : [phenotype.inheritance],
      disease: isArray ? phenotype.disease[i] : phenotype.disease
    }))
  })), 'disease_score', 'desc') : []
  return phenotypes
}

export const getClinvarACMGMapDatas = (values, type = 'default') => {
  let ary = values ? values.split(/,|\||\//).map(value => (value || 'N/A').replace(/_/g, ' ').trim()) : ['N/A']
  let map = {
    default: clinvarACMGMap,
    report: clinvarACMGMap
  }[type]
  let datas = sortData(ary.map(value => (map[value] ? {
    ...map[value],
    display_zh: reportClinvarACMGZHMap[value]
  } : {
    display: value,
    title: value,
    color: '#AAAAAA',
    index: -1
  })), data => data.index, 'desc')
  return datas
}

export const getClinvarStatisticData = clinvarStatistic => {
  const defaultDataGenerator = () => ({
    n: 0
  })
  const defaultTableConfig = {
    'gs': {
      'title': {
        data: false,
        title: [
          'Coding Impact'
        ].join(' ')/* ___ */,
        flex: 146,
        color: '#FFFFFF'
      },
      'Pathogenic': {
        title: [
          'Pathogenic'
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#FA3D3D'
      },
      'Likely_pathogenic': {
        title: [
          'Likely',
          'Pathogenic'
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#FF9E03'
      },
      'Conflicting_interpretations_of_pathogenicity': {
        title: [
          'Conflicting interpretations',
          'of pathogenicity'
        ].join(' ')/* ___ */,
        flex: 210,
        color: '#999999'
      },
      'Uncertain_significance': {
        title: [
          'Uncertain',
          'Significance'
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#F8C600'
      },
      'Likely_benign': {
        title: [
          'Likely benign'
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#83C91E'
      },
      'Benign': {
        title: [
          'Benign'
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#349CCF'
      },
      'total': {
        data: false,
        title: [
          'Total'
        ].join(' ')/* ___ */,
        flex: 135,
        color: '#FFFFFF'
      }
    },
    'csq': {
      'title': {
        data: false,
        title: [
          'Coding Impact'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'stop_gained': {
        title: [
          'Stop Gained'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'splice_site': {
        title: [
          'Splice Site'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'frameshift': {
        title: [
          'Frameshift',
          'Variant'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'stop_lost': {
        title: [
          'Stop Lost'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'start_lost': {
        title: [
          'Start Lost'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'missense': {
        title: [
          'Missense'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'inframe_indel': {
        title: [
          ' Inframe Indel'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'synonymous': {
        title: [
          'Synonymous',
          'Variant'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'non_coding': {
        title: [
          'Non Coding'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      },
      'total': {
        data: false,
        title: [
          'Total'
        ].join(' ')/* ___ */,
        flex: 1,
        color: '#FFFFFF'
      }
    }
  }
  let clinvarTableData = {}
  clinvarTableData['function'] = {
    getOpacity: p => {
      if (p === 0) return '00'
      else if (p < 0.02) return '02'
      else if (p <= 0.1) return '10'
      else if (p <= 0.2) return '20'
      else if (p <= 0.3) return '30'
      else if (p <= 0.4) return '40'
      else if (p <= 0.5) return '50'
      else if (p <= 0.6) return '60'
      else if (p <= 0.7) return '70'
      else if (p <= 0.8) return '80'
      else if (p <= 0.9) return '90'
      else return ''
    }
  }
  clinvarTableData['config'] = defaultTableConfig
  clinvarTableData['data'] = {
    gs: {
      ...Object.entries(defaultTableConfig['gs']).filter(([_, value]) => value.data !== false).reduce((r, [key]) => ({
        ...r,
        [key]: {
          ...Object.entries(defaultTableConfig['csq']).filter(([_, value]) => value.data !== false).reduce((r, [key]) => ({
            ...r,
            [key]: defaultDataGenerator()
          }), {}),
          total: 0
        }
      }), {}),
      total: 0
    },
    csq: {
      ...Object.entries(defaultTableConfig['csq']).filter(([_, value]) => value.data !== false).reduce((r, [key]) => ({
        ...r,
        [key]: {
          ...Object.entries(defaultTableConfig['gs']).filter(([_, value]) => value.data !== false).reduce((r, [key]) => ({
            ...r,
            [key]: defaultDataGenerator()
          }), {}),
          total: 0
        }
      }), {}),
      total: 0
    }
  }
  for (let data of clinvarStatistic) {
    let keys = {
      gs_clinsig: data.gs_clinsig.replace(/_variant$/, ''),
      csq: data.csq.replace(/_variant$/, '')
    }
    clinvarTableData['data']['gs'].total += data.n
    clinvarTableData['data']['gs'][keys.gs_clinsig].total += data.n
    clinvarTableData['data']['gs'][keys.gs_clinsig][keys.csq].n += data.n
    clinvarTableData['data']['csq'].total += data.n
    clinvarTableData['data']['csq'][keys.csq].total += data.n
    clinvarTableData['data']['csq'][keys.csq][keys.gs_clinsig].n += data.n
  }
  return clinvarTableData
}

export const clinvarACMGMap = {
  'Pathogenic': {
    display: 'Pathogenic',
    title: 'Pathogenic',
    color: '#FA3D3D',
    index: 12
  },
  'Pathogenic/Likely pathogenic': {
    display: 'Pathogenic/Likely pathogenic',
    title: 'Pathogenic/Likely pathogenic',
    color: '#FF9E03',
    index: 5
  },
  'Likely pathogenic': {
    display: 'Likely pathogenic',
    title: 'Likely pathogenic',
    color: '#FF9E03',
    index: 11
  },
  'Conflicting interpretations of pathogenicity': {
    display: 'Conflicting interpretations of pathogenicity',
    title: 'Conflicting interpretations of pathogenicity',
    color: '#F8C600',
    index: 10
  },
  'Uncertain significance': {
    // display: 'VUS',
    // title: 'Variant of Uncertain Significance',
    display: 'Uncertain significance',
    title: 'Uncertain significance',
    color: '#F8C600',
    index: 9
  },
  'risk factor': {
    display: 'risk factor',
    title: 'risk factor',
    color: '#FF0000',
    index: 8
  },
  'Benign': {
    display: 'Benign',
    title: 'Benign',
    color: '#006ED6',
    index: 6
  },
  'Benign/Likely benign': {
    display: 'Benign/Likely benign',
    title: 'Benign/Likely benign',
    color: '#83C91E',
    index: 4
  },
  'Likely benign': {
    display: 'Likely benign',
    title: 'Likely benign',
    color: '#83C91E',
    index: 7
  },
  'drug response': {
    display: 'drug response',
    title: 'drug response',
    color: '#F8C600',
    index: 3
  },
  'protective': {
    display: 'protective',
    title: 'protective',
    color: '#F8C600',
    index: 2
  },
  'other': {
    display: 'other',
    title: 'other',
    color: '#333333',
    index: 1
  },
  'N/A': {
    display: 'N/A',
    title: 'N/A',
    color: '#AAAAAA',
    index: 0
  }
}

export const reportGTMap = {
  'heterozygous': 'hetero<br>(雜合子)',
  'homozygous': 'homo<br>(純合子)',
  'hemizygous': 'hemi<br>(半合子)',
  'heterozygote': 'hetero<br>(雜合子)',
  'homozygote': 'homo<br>(純合子)',
  'hemizygote': 'hemi<br>(半合子)'
}

export const reportEnGTMap = {
  'heterozygous': 'hetero',
  'homozygous': 'homo',
  'hemizygous': 'hemi',
  'heterozygote': 'hetero',
  'homozygote': 'homo',
  'hemizygote': 'hemi'
}

export const reportClinvarACMGZHMap = {
  'Benign': '良性的',
  'Benign/Likely benign': '良性的/可能良性的',
  'Conflicting interpretations of pathogenicity': '致病性意義衝突',
  'Likely benign': '可能良性的',
  'drug response': '藥物反應',
  'risk factor': '風險因子',
  'protective': '有保護性的',
  'Uncertain significance': '不明確的',
  'Pathogenic': '致病的',
  'other': '其他',
  'Likely pathogenic': '可能致病的',
  'Pathogenic/Likely pathogenic': '致病的/可能致病的',
  'Affects': '非疾病相關表徵反應'
}

export const reportCNVTypeMap = {
  'deletion': 'Deletion',
  'duplication': 'Duplication',
  'insertion': 'Insertion'
}

export const reportParentalOriginMap = {
  'De novo': 'De novo',
  'Paternal': 'Paternal',
  'Maternal': 'Maternal',
  'Biparental': 'Biparental',
  'Unknown': 'Unknown'
}

export const acmgMap = {
  // BA
  BA1: {
    title: 'BA1',
    type: 'Strong',
    class: 'benign-strong',
    informations: [
      'Allele frequency is >5% in population databases.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  // BS
  BS1: {
    title: 'BS1',
    type: 'Strong',
    class: 'benign-strong',
    informations: [
      'Allele frequency is greater than expected for disorder.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  BS2: {
    title: 'BS2',
    type: 'Strong',
    class: 'benign-strong',
    informations: [
      'Observed in a healthy adult individual for a recessive (homozygous), dominant (heterozygous), or X-linked (hemizygous) disorder, with full penetrance expected at an early age.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  BS4: {
    title: 'BS4',
    type: 'Strong',
    class: 'benign-strong',
    informations: [
      'Lack of segregation in affected members of a family.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  BS3: {
    title: 'BS3',
    type: 'Strong',
    class: 'benign-strong',
    informations: [
      'Well-established in vitro or in vivo functional studies show no damaging effect on protein function or splicing.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  // BP
  BP2: {
    title: 'BP2',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'Observed in trans with a pathogenic variant for a fully penetrant dominant gene/disorder or observed in cis with a pathogenic variant in any inheritance pattern.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  BP5: {
    title: 'BP5',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'Variant found in a case with an alternate molecular basis for disease.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  BP1: {
    title: 'BP1',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'Missense variant in a gene for which primarily truncating variants are known to cause disease.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  BP3: {
    title: 'BP3',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'In-frame deletions/insertions in a repetitive region without a known function.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  BP4: {
    title: 'BP4',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'Multiple lines of computational evidence suggest no impact on gene or gene product (conservation, evolutionary, splicing impact, etc.).'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  BP7: {
    title: 'BP7',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'A synonymous (silent) variant for which splicing prediction algorithms predict no impact to the splice consensus sequence nor the creation of a new splice site AND the nucleotide is not highly conserved.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  BP6: {
    title: 'BP6',
    type: 'Supporting',
    class: 'benign-supporting',
    informations: [
      'Reputable source recently reports variant as benign, but the evidence is not available to the laboratory to perform an independent evaluation.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  // PP
  PP1: {
    title: 'PP1',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: [
      'Cosegregation with disease in multiple affected family members in a gene definitively known to cause the disease.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PP2: {
    title: 'PP2',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: [
      'Missense variant in a gene that has a low rate of benign missense variation and in which missense variants are a common mechanism of disease.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PP3: {
    title: 'PP3',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: [
      'Multiple lines of computational evidence support a deleterious effect on the gene or gene product (conservation, evolutionary, splicing impact, etc.).'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PP4: {
    title: 'PP4',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: [
      'Patient’s phenotype or family history is highly specific for a disease with a single genetic etiology.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PP5: {
    title: 'PP5',
    type: 'Supporting',
    class: 'pathogenic-supporting',
    informations: [
      'Reputable source recently reports variant as pathogenic, but the evidence is not available to the laboratory to perform an independent evaluation.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  // PM
  PM2: {
    title: 'PM2',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'Absent from controls (or at extremely low frequency if recessive) in population databases.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PM3: {
    title: 'PM3',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'For recessive disorders, detected in trans with a pathogenic variant.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PM6: {
    title: 'PM6',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'Assumed de novo, but without confirmation of paternity and maternity.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PM1: {
    title: 'PM1',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'Located in a mutational hot spot and/or critical and well-established functional domain (e.g., active site of an enzyme) without benign variation.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PM4: {
    title: 'PM4',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'Protein length changes as a result of in-frame deletions/insertions in a nonrepeat region or stop-loss variants.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PM5: {
    title: 'PM5',
    type: 'Moderate',
    class: 'pathogenic-moderate',
    informations: [
      'Novel missense change at an amino acid residue where a different missense change determined to be pathogenic has been seen before.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  // PS
  PS4: {
    title: 'PS4',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: [
      'The prevalence of the variant in affected individuals is significantly increased compared with the prevalence in controls.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PS2: {
    title: 'PS2',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: [
      'De novo (both maternity and paternity confirmed) in a patient with the disease and no family history.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PS1: {
    title: 'PS1',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: [
      'Same amino acid change as a previously established pathogenic variant regardless of nucleotide. change.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  PS3: {
    title: 'PS3',
    type: 'Strong',
    class: 'pathogenic-strong',
    informations: [
      'Well-established in vitro or in vivo functional studies supportive of a damaging effect on the gene or gene product.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  },
  // PVS
  PVS1: {
    title: 'PVS1',
    type: 'Very Strong',
    class: 'pathogenic-very-strong',
    informations: [
      'null variant (nonsense, frameshift, canonical ±1 or 2 splice sites, initiation codon, single or multiexon deletion) in a gene where LOF is a known mechanism of disease.'
    ],
    explanations: [
      '// EXPLANATIONS',
      '// EXPLANATIONS'
    ]
  }
}

export const datasetStatusMap = {
  created: {
    title: 'created'/* ___ */,
    color: '#333333'
  },
  analyzing: {
    title: 'Analyzing…'/* ___ */,
    color: '#83C91E'
  },
  completed: {
    title: 'Done'/* ___ */,
    color: '#003679'
  },
  failed: {
    title: 'Failed'/* ___ */,
    color: '#BE0F0F'
  },
  disabled: {
    title: 'Disabled'/* ___ */,
    color: '#BE0F0F'
  }
}

export const datasetPermissionTypeMap = {
  private: {
    title: 'Private'/* ___ */
  },
  community: {
    title: 'Community'/* ___ */
  }
}

export const datasetPermissionMap = {
  private: {
    title: 'Private'/* ___ */,
    color: '#BE0F0F',
    type: 'private'
  },
  basic: {
    title: 'Basic'/* ___ */,
    color: '#333333',
    type: 'community'
  },
  explore: {
    title: 'Data Explore'/* ___ */,
    color: '#003679',
    type: 'community'
  },
  full: {
    title: 'Full access'/* ___ */,
    color: '#83C91E',
    type: 'community'
  }
}

export const datasetInvitationPermissionMap = {
  explore: {
    title: 'Data Explore'/* ___ */
  },
  full: {
    title: 'Full access'/* ___ */
  }
}

export const datasetPipelineMap = {
  WES: {
    title: 'Whole Exome Sequencing'/* ___ */
  },
  WGS: {
    title: 'Whole Genome Sequencing'/* ___ */
  }
}

export const datasetShareAlert = dataset => {
  if (dataset.external_data_included) return 'Because it contains community data. If you want to share dataset, create a dataset with all your data.'/* ___ */
  if (dataset.disabled) return 'Because dataset is disable'/* ___ */
  if (['analyzing'].includes(dataset.state)) return 'Because data analysis is processing'/* ___ */
  if (['created', 'failed'].includes(dataset.state)) return 'Because data analysis is failed'/* ___ */
  return null
}



// WEBPACK FOOTER //
// ./src/constants/global/data.js